import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Emily Johnson', 
        title: 'Marketing Manager',
        content: 'The conference experience was absolutely outstanding! The speakers were incredibly insightful, and I learned so much about the latest industry trends and innovations. I left feeling truly inspired and ready to take immediate action.'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'James Smith', 
        title: 'Software Engineer',
        content: 'Attending the conference opened many exciting doors for collaboration! I met so many fantastic professionals and exchanged valuable ideas and insights. The networking opportunities were truly invaluable and refreshing.'
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Sarah Lee', 
        title: 'Project Manager',
        content: 'The workshops were highly interactive and incredibly beneficial. I gained practical skills that I can implement in my upcoming projects right away! The hands-on approach was truly effective and engaging.'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Michael Brown', 
        title: 'Entrepreneur',
        content: 'This conference was incredibly well-organized and very enjoyable! I thoroughly enjoyed the sessions and the chance to network with so many amazing attendees. Every moment was filled with valuable insights and experiences.'
    },
];

export default testimonials;